type SectionContent = {
  src: string;
  title: string;
  description: string;
};

export type SeoPage = {
  slug: string;
  title: string;
  description: string;
  content: SectionContent[];
  channelNameToLinkTo?: string;
  includeCommunityImagesSection?: boolean;
};

const landingPageImageUrl1 = '/secondImgLand.webp';
const landingPageImageUrl2 = '/firstImgLand.webp';
export const landingPageImageUrl3 = '/thirdImgLand.webp';

export const sectionContentLandingPage: SectionContent = {
  src: landingPageImageUrl1,
  title: 'TheUncensored.AI: Your Free, Unrestricted AI App',
  description:
    'Explore our free to try, unfiltered AI Image Generator and AI Chat. Create stunning AI-generated images and chat with AI characters — no sign-up required to try it out! Enjoy the freedom of unrestricted AI, designed for limitless creativity and seamless sharing',
};

export const sectionContentLandingPage2: SectionContent = {
  src: landingPageImageUrl2,
  title: 'Create any images',
  description:
    'Unleash your creativity with our uncensored AI image generator. Generate anything from realistic portraits to hentai characters—no content restrictions, no filters. Experience true creative freedom with private, anonymous processing powered by cutting-edge AI models. Perfect for artists, content creators, and anyone exploring AI-generated art without limitations.',
};

export const sectionContentLandingPage3: SectionContent = {
  src: landingPageImageUrl3,
  title: 'Chat with unfiltered AIs',
  description:
    'Engage with our massive collection of community-created AI personas for authentic, unfiltered conversations. Experience true free speech AI with no moralizing filters—perfect for roleplay, NSFW dialogues, or private conversations. Explore trending characters, create your own chatbot persona, and enjoy anonymous interactions powered by advanced conversational AI models.',
};

const seoPage1: SeoPage = {
  slug: 'ai-girl-generator',
  title: 'AI Girl Generator: Create Stunning AI-Generated Girls & Waifus',
  description:
    'Design your perfect AI girl with our advanced AI girl generator. Create anime waifus, realistic female characters, and fantasy companions with uncensored, customizable features. Experience the best in AI porn, NSFW image generation, and creative freedom—no filters, no limits.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'Create Your Perfect AI Girl with Uncensored AI Image Generator',
      description:
        'Our AI girl generator lets you design stunning, lifelike female characters with ease. Whether you want to create anime waifus, realistic portraits, or fantasy heroines, our platform gives you full control over every detail—hairstyles, outfits, body type, and facial expressions. The uncensored AI image editor ensures you can generate NSFW, SFW, or artistic images without restrictions. Use the AI girl generator for character design, concept art, or personal projects. With advanced neural networks, you get hyper-realistic results in seconds. No artistic skills required—just describe your dream girl and let the AI bring her to life. Enjoy private, anonymous processing and explore the world of AI porn, hentai ai, and unrestricted creativity.',
    },
    {
      src: landingPageImageUrl2,
      title: 'Next-Gen AI Waifu & NSFW Image Generator',
      description:
        'Experience the future of AI image generation with our next-gen AI girl generator. Create anime-style waifus, realistic companions, or fantasy characters for any scenario. The platform supports NSFW ai image generation, cosplay ideas, and virtual influencers—all with complete privacy and no content filters. Generate AI porn, hentai, or SFW art for your stories, games, or social media. Our intuitive controls and uncensored AI technology make it easy to customize every aspect of your character. Whether you want to explore new fantasies or bring your creative visions to life, our AI girl generator is the ultimate tool for artists, writers, and fans of ai porn and nsfw ai image generators.',
    },
  ],
};

const seoPage2: SeoPage = {
  slug: 'nsfw-ai-chat',
  title: 'NSFW AI Chat: Uncensored Free AI Porn Chatbot',
  description:
    'Chat with uncensored NSFW AI chatbots for free. Experience adult conversations, erotic roleplay, and AI porn chat with no filters, no logs, and total privacy. The best free NSFW AI chat for exploring fantasies and connecting with AI companions.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'Free NSFW AI Chat: Uncensored Adult Conversations',
      description:
        'Start chatting instantly with our NSFW AI chatbot—no sign up, no restrictions. Engage in erotic roleplay, explore fantasies, or simply enjoy adult conversations with AI personas designed for mature interactions. Our platform uses advanced neural networks to deliver realistic, context-aware responses, making every chat immersive and private. The NSFW AI chat is perfect for those seeking free ai porn chat, uncensored ai chat, or a safe space to discuss adult topics. All conversations are processed anonymously, with no logs or content filters, ensuring your privacy and freedom. Whether you want to flirt, roleplay, or just talk, our NSFW AI chatbot adapts to your desires and keeps your secrets safe.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Next-Gen NSFW AI Chatbot for Adult Roleplay',
      description:
        'Experience the next generation of NSFW AI chat with customizable AI companions. Choose personality traits, conversation styles, and intimacy levels for a truly personalized experience. Our AI understands nuanced language, context, and even supports NSFW image sharing for a multi-sensory chat. Perfect for exploring fantasies, practicing communication, or enjoying private AI porn chat. The platform is designed for total anonymity and freedom, making it the best choice for free nsfw ai chat, ai chat nsfw, and unrestricted adult conversations online.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPage3: SeoPage = {
  slug: 'dnd-ai-art-generator',
  title: 'D&D AI Art Generator: Fantasy & NSFW AI Image Creation',
  description:
    'Bring your D&D campaigns to life with our D&D AI art generator. Create fantasy characters, magical items, and NSFW art with uncensored AI image generation. Perfect for DMs, players, and artists seeking unique, customizable fantasy visuals.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/06995f1c-14ee-418c-b05e-fbbcf6a1a7f4.jpeg',
      title: 'AI-Powered D&D Art: Uncensored Fantasy Image Generator',
      description:
        'Our D&D AI art generator empowers you to create custom fantasy art for your tabletop campaigns. Design party portraits, NPCs, magical items, and immersive landscapes with ease. The uncensored AI image generator supports both SFW and NSFW content, allowing you to visualize mature campaigns or unique creatures without limitations. Use the D&D AI art generator for character sheets, battle maps, or concept art. With advanced AI models, you can generate high-quality images in any style, from classic medieval to dark fantasy. Enjoy private, anonymous processing and unleash your creativity with the best ai image generator for D&D and fantasy art.',
    },
    {
      src: landingPageImageUrl2,
      title: 'Next-Gen Fantasy & NSFW AI Art Creation',
      description:
        'Craft detailed D&D assets with our drag-and-drop AI generator. Create magical item illustrations, character portraits, and entire scene landscapes in seconds. The platform supports NSFW fantasy art, unique creatures, and immersive visuals for any campaign. Perfect for dungeon masters, players, and artists who want to bring their stories to life. The D&D AI art generator is your go-to tool for fantasy ai art, nsfw ai image generation, and unrestricted creative expression.',
    },
  ],
};

const seoPage4: SeoPage = {
  slug: 'ai-sex-chat-bot',
  title: 'AI Sex Chat Bot: Uncensored NSFW AI Chat & Roleplay',
  description:
    'Experience realistic, uncensored NSFW chat with our AI sex chat bot. Engage in erotic roleplay, adult conversations, and AI porn chat with customizable AI partners. Total privacy, no filters, and adaptive personalities for the best AI sex chat experience.',
  content: [
    {
      src: landingPageImageUrl3,
      title: 'Realistic AI Sex Chat: Uncensored NSFW AI Chatbot',
      description:
        "Interact with advanced AI companions for mature, intimate conversations. Customize your partner's personality, kinks, and chat style for a truly personal experience. The AI sex chat bot adapts to your preferences, creating immersive roleplay scenarios with emotional intelligence and contextual understanding. Enjoy private, anonymous processing and explore the world of ai porn, nsfw ai chat, and uncensored ai chatbots. Perfect for exploring desires, practicing communication, or virtual companionship—no judgment, no filters, just authentic adult conversations.",
    },
    {
      src: landingPageImageUrl2,
      title: 'Next-Gen Erotic AI Chat & NSFW Image Generation',
      description:
        'Explore cutting-edge AI sex chat technology with voice-to-text input, NSFW image generation, and adaptive dialogue. Engage in multi-sensory adult conversations featuring memory retention, fantasy scenario building, and dynamic roleplay. The AI sex chat bot is perfect for those seeking ai porn chat, nsfw ai chatbot, and unrestricted adult interactions—all processed privately with end-to-end encryption.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPage5: SeoPage = {
  slug: 'sexting-ai-chat',
  title: 'Sexting AI Chat: Free NSFW AI Sexting & Porn Chatbot',
  description:
    'Enjoy realistic, uncensored sexting with our advanced AI sexting chatbot. Experience adaptive NSFW responses, multimedia support, and total privacy—no filters, no logs, just authentic AI porn chat and intimate interactions.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'Next-Level Sexting AI: Uncensored NSFW Chatbot',
      description:
        'Discover immersive AI-powered sexting with natural language understanding and erotic context awareness. Craft personalized scenarios, exchange NSFW media, and enjoy real-time adaptive responses—all protected by military-grade encryption and anonymous processing. The sexting AI chat is perfect for exploring fantasies, enhancing relationships, or simply enjoying free ai porn chat with no restrictions. Our AI chatbot evolves with your style, offering dynamic roleplay, erotic image generation, and emotional intelligence for the most realistic sexting experience online.',
    },
    {
      src: landingPageImageUrl1,
      title: 'Smart Sexting AI: Free NSFW AI Porn Chat',
      description:
        'Interact with an AI that adapts to your preferences and fantasies. Features include persona creation, backstory customization, and erotic image generation mid-chat. The sexting AI chat is ideal for those seeking free nsfw ai chat, ai porn free, and unrestricted adult conversations. Enjoy 200+ WPM responses, sensual vocabulary, and total privacy—no logs, no filters, just pure AI-powered sexting.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPage6: SeoPage = {
  slug: 'nude-ai',
  title: 'Nude AI: Uncensored NSFW AI Nude Image Generator',
  description:
    'Generate realistic nude AI images and NSFW art with our uncensored AI nude generator. Create perfect bodies, artistic nudes, and erotic scenes—no filters, no censorship, and total privacy for your AI porn and NSFW image needs.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'AI Nude Generator: Realistic Uncensored NSFW Images',
      description:
        'Create flawless nude AI art with precise body customization. Adjust proportions, poses, and lighting for anatomically accurate results. Generate artistic nudes, boudoir photography, or explicit NSFW content with complete creative freedom. The nude AI generator is perfect for artists, content creators, and anyone seeking ai porn, naked ai, or uncensored ai image generation. All images are processed privately and securely, ensuring your privacy and anonymity.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Nude AI: NSFW Image Generator & Art Tool',
      description:
        'Craft hyper-realistic nude images with our advanced AI generator. Perfect for life drawing references, adult content creation, or exploring human form artistry. The nude AI generator supports 4K resolution, professional-grade detail, and full customization. Enjoy the best in nsfw ai image generation, ai porn generator, and unrestricted nude art creation—all with private, encrypted processing.',
    },
  ],
};

const seoPage7: SeoPage = {
  slug: 'onlyfakes-ai-image-generator',
  title: 'OnlyFakes AI Image Generator: Create Hyper-Realistic Fake Images',
  description:
    'Generate convincing fake images with our OnlyFakes AI image generator. Create realistic photos for cosplay, alternate personas, or creative projects—complete privacy, no watermarks, and unlimited customization. The best tool for ai porn, fake nudes, and nsfw ai image generation.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'AI-Powered Fake Image Generator: Uncensored & Realistic',
      description:
        'Craft flawless fake images using advanced AI technology. Generate realistic images with customizable backgrounds, clothing, and facial expressions. The OnlyFakes AI image generator is perfect for content creators, roleplayers, and privacy-conscious users needing alternate visual identities. Use it for ai porn, fake nudes, or creative projects—no watermarks, no restrictions, just pure AI-powered image generation. All images are processed anonymously and securely, ensuring your privacy and creative freedom.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Next-Gen Fake Image Technology: NSFW & SFW AI Generation',
      description:
        'Create AI-generated images with our proprietary neural networks. Features include full-body image generation, document template customization, and advanced editing tools. Generate fake couple photos, social media content, or fantasy personas—all with military-grade encryption and no content filters. The OnlyFakes AI image generator is your go-to tool for ai porn, nsfw ai image generation, and unrestricted creative expression.',
    },
  ],
};

const seoPage8: SeoPage = {
  slug: 'hijab-ai-nude',
  title: 'Hijab AI Nude Generator: Culturally Authentic NSFW AI Art',
  description:
    'Create culturally sensitive hijab-themed nude art with our hijab AI nude generator. Generate hijab nudes with anatomical accuracy, customizable styles, and total privacy—no censorship, no filters, and secure processing for ai porn and nsfw ai image needs.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/b793d27e-0b71-4c9c-9eed-01ec6b253929.webp',
      title: 'Hijab-Centric AI Nude Generation: Uncensored NSFW Art',
      description:
        'Craft culturally authentic hijab nude art with our specialized AI models. Adjust fabric patterns, body modesty levels, and lighting while maintaining artistic integrity. The hijab AI nude generator supports both traditional and modern interpretations, allowing you to create unique, respectful, and uncensored NSFW art. All images are processed securely and privately, making it the best tool for ai porn, nsfw ai image generation, and culturally diverse nude art.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Hijab AI Art: NSFW Image Generator',
      description:
        'Create hyper-realistic hijab-themed nudes with anatomical precision. Features include customizable wardrobe elements, dynamic posing, and cultural accessory integration. The hijab AI nude generator is powered by ethical AI trained for diverse cultural representations, ensuring your art is both authentic and uncensored. Perfect for artists, content creators, and anyone seeking ai porn, nsfw ai, or culturally sensitive nude image generation.',
    },
  ],
  channelNameToLinkTo: 'hijab',
};

const seoPage9: SeoPage = {
  slug: 'ai-mature-nude',
  title: 'AI Mature Nude Generator: Realistic NSFW AI Art for Adults',
  description:
    'Create tasteful mature nude art with our AI mature nude generator. Generate realistic 30+ nude figures, customizable body types, and poses—total privacy, no content filters, and the best in ai porn and nsfw ai image generation for adults.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/112b770e-7bbe-46d8-be86-1a403e0e780b.jpeg',
      title: 'Realistic Mature Nude Generation: Uncensored AI Art',
      description:
        'Craft sophisticated nude art featuring natural mature bodies with our AI technology. Adjust body composition, skin texture, and lighting for realistic results. The AI mature nude generator is perfect for life drawing references, artistic projects, or body positivity content. All images are processed privately and securely, making it the best tool for ai porn, nsfw ai image generation, and mature nude art. Enjoy complete creative freedom and privacy with no content filters or restrictions.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Mature Anatomy AI: NSFW Image Generator',
      description:
        'Generate hyper-realistic mature nudes with professional-grade detail. Features include age-specific body customization, dynamic posing, and realistic skin imperfection options. The AI mature nude generator is ideal for artists, educators, and content creators needing ethically-sourced mature human references. Enjoy the best in ai porn, nsfw ai, and mature nude image generation—all with secure, anonymous processing.',
    },
  ],
  channelNameToLinkTo: 'mature',
};

const seoPage10: SeoPage = {
  slug: 'uncensored-ai-xxx',
  title: 'Uncensored AI XXX: Private NSFW AI Porn Generator',
  description:
    'Generate unrestricted XXX content with our uncensored AI porn generator. Create explicit images, adult videos, and NSFW animations—no filters, no censorship, and total privacy. The best tool for ai porn, nsfw ai, and uncensored ai image generation.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'Ultimate Uncensored AI XXX Generator: NSFW AI Porn',
      description:
        'Create explicit AI-generated content with zero restrictions. Generate realistic XXX material, adult animations, and NSFW scenarios with precise customization. The uncensored AI porn generator ensures private processing and complete anonymity, making it ideal for adult content creators, erotic artists, and fantasy exploration. Enjoy the best in ai porn, nsfw ai image generation, and uncensored ai content creation—all with military-grade privacy protection.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Next-Gen AI for Adult Content Creation: NSFW & XXX',
      description:
        'Produce high-quality XXX content using our advanced uncensored AI models. Features include multi-modal generation (videos, GIFs, images), dynamic posing, and adaptive erotic context recognition. Generate niche fetish content, adult animations, or realistic NSFW scenes with total privacy and no content filters. The uncensored AI porn generator is your go-to tool for ai porn, nsfw ai, and unrestricted adult content.',
    },
  ],
};

const seoPage11: SeoPage = {
  slug: 'free-ai-porn-chat',
  title: 'Free AI Porn Chat: Uncensored NSFW AI Chatbot',
  description:
    'Experience free AI porn chat with no sign up required. Engage in uncensored NSFW conversations, erotic roleplay, and AI porn chat instantly—no email, no credit card, and total privacy. The best free nsfw ai chat for adult entertainment.',
  content: [
    {
      src: landingPageImageUrl3,
      title: 'Instant Access Free AI Porn Chat: NSFW AI Chatbot',
      description:
        'Start NSFW conversations immediately with our free AI porn chat—no sign up, no barriers. Enjoy unfiltered adult dialogues, erotic roleplay, and explicit content generation with complete anonymity. The free AI porn chat is perfect for exploring fantasies, practicing communication, or simply enjoying adult entertainment. All chats are processed privately, with no logs or content filters, ensuring your privacy and freedom. The platform supports real-time NSFW image generation, adaptive personality matching, and multi-language support for a truly global experience.',
    },
    {
      src: landingPageImageUrl2,
      title: 'Unrestricted Free NSFW AI Sex Chat: No Registration Needed',
      description:
        'Engage in pornographic AI conversations without any barriers. Features include real-time NSFW image generation, adaptive personality matching, and multi-language support—all free with no registration. The free AI porn chat is ideal for those seeking ai porn free, nsfw ai chat, and unrestricted adult conversations online. Enjoy total privacy, instant access, and the best in AI-powered adult entertainment.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPage12: SeoPage = {
  slug: 'blonde-ai-nude',
  title: 'Blonde AI Nude Generator: Realistic NSFW AI Art',
  description:
    'Create stunning blonde nude art with our blonde AI nude generator. Generate realistic blonde figures, customizable hair shades, and poses—total privacy, no content filters, and the best in ai porn and nsfw ai image generation.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'AI-Generated Blonde Nudes: Uncensored NSFW Art',
      description:
        'Craft perfect blonde nude art with precise control over hair color, body proportions, and lighting. The blonde AI nude generator supports natural blonde variations, realistic skin textures, and facial features for authentic results. All images are processed privately and securely, making it the best tool for ai porn, nsfw ai image generation, and blonde nude art. Enjoy complete creative freedom, no content filters, and total privacy for your artistic or personal projects.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Blonde Anatomy AI: NSFW Image Generator',
      description:
        'Produce hyper-realistic blonde nudes with professional-grade detail. Features include dynamic posing, customizable hairstyles, and ethnic diversity options. The blonde AI nude generator is ideal for artists, content creators, and anyone seeking ai porn, nsfw ai, or realistic blonde nude image generation. All images are processed with secure, anonymous processing for your peace of mind.',
    },
  ],
  channelNameToLinkTo: 'blondes',
};

const seoPage13: SeoPage = {
  slug: 'uncensored-sex-ai',
  title: 'Uncensored Sex AI: Private NSFW AI Chat & Image Generator',
  description:
    'Experience unfiltered AI sex interactions with our uncensored sex AI platform. Engage in NSFW chats, generate explicit images, and explore fantasies with zero restrictions—private processing, no content filters, and military-grade encryption for total anonymity.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'True Uncensored Sex AI: NSFW Chat & Image Generation',
      description:
        'Interact with AI that understands adult content without limitations. Features include real-time NSFW image generation during chats, adaptive erotic roleplay scenarios, and multi-sensory conversation capabilities. The uncensored sex AI platform is perfect for those seeking ai porn, nsfw ai chat, and unrestricted adult content. All interactions are processed anonymously, with end-to-end encryption for your privacy and security.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Next-Gen Uncensored AI Technology: NSFW & Porn AI',
      description:
        'Generate explicit content and engage in adult conversations powered by advanced neural networks. Create custom sex AI personas, generate hyper-realistic NSFW images, and enjoy voice-enabled interactions. The uncensored sex AI platform is your go-to tool for ai porn, nsfw ai, and unfiltered adult content creation—all with automatic data purging after sessions.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPage14: SeoPage = {
  slug: 'futa-ai-porn',
  title: 'Futa AI Porn Generator: Uncensored NSFW AI Content',
  description:
    'Create hyper-realistic futa-themed AI porn with our futa AI porn generator. Generate custom futa characters, NSFW art, and fantasy scenes—no content filters, dynamic posing, and total privacy for your ai porn and nsfw ai image needs.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/c5b4feeb-70fb-42d3-9a65-6d98b402468c.jpeg',
      title: 'AI Futa Porn Generation: Uncensored NSFW Art',
      description:
        'Craft detailed futa characters with our advanced AI generator. Adjust anatomical proportions, hairstyles, and scenarios for realistic results. The futa AI porn generator supports NSFW content, erotic art, and fantasy scenes—all processed privately and securely. Perfect for those seeking ai porn, nsfw ai, and futa-themed adult content. Enjoy complete creative freedom, no content filters, and military-grade privacy protection.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Next-Gen Futa AI Technology: NSFW & Porn AI',
      description:
        'Produce high-quality futa porn with professional-grade detail. Features include multi-character generation, interactive scenarios, and adaptive erotic context recognition. The futa AI porn generator is your go-to tool for ai porn, nsfw ai, and niche adult content creation—all with secure, anonymous processing and automatic data purging.',
    },
  ],
  channelNameToLinkTo: 'futa',
};

const seoPage15: SeoPage = {
  slug: 'ai-hentai',
  title: 'AI Hentai Generator – Uncensored Hentai AI Art & NSFW Images',
  description:
    'Create uncensored hentai art with the best AI hentai generator. Generate anime-style NSFW images, custom waifus, and explicit hentai scenes with full privacy and no content restrictions. Try the top hentai AI for free and explore limitless adult creativity.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/845fdd45-a36a-447f-aff7-3e4bd2b50160.jpeg',
      title: 'Uncensored AI Hentai Art Generator',
      description:
        'Discover the next generation of AI hentai creation. Our uncensored AI hentai generator lets you design detailed anime-style characters, explicit NSFW scenes, and custom waifus with total control over body features, outfits, and poses. Whether you want to create SFW or NSFW hentai art, our platform offers advanced pose control, background customization, and high-resolution output. Perfect for manga artists, anime fans, and anyone seeking creative freedom, this hentai AI tool removes all content filters and ensures your privacy with secure, anonymous processing. Generate hentai art in 4K, experiment with different styles, and bring your wildest anime fantasies to life with the best hentai AI generator online.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Hentai AI Technology for NSFW Art',
      description:
        'Our hentai AI generator uses state-of-the-art anime AI models to create hyper-detailed hentai artwork. Enjoy features like dynamic lighting, multi-character scenes, and authentic Japanese art styles. Generate private commissions, erotic manga panels, or unique character concepts with secure, private processing. The platform is designed for both beginners and professionals, offering intuitive controls and endless customization. Experience the freedom of uncensored hentai AI art and join a growing community of adult anime creators. Try the best hentai AI generator for free and unlock new possibilities in NSFW anime art.',
    },
  ],
  channelNameToLinkTo: 'hentai',
};

const seoPage16: SeoPage = {
  slug: 'uncensored-ai',
  title: 'Uncensored AI – NSFW AI Chat & Unfiltered Adult Image Generator',
  description:
    'Experience the leading uncensored AI for NSFW chat and adult content generation. Create explicit images, videos, and erotic scenarios with no content filters. Enjoy private, anonymous processing and military-grade encryption for secure, unrestricted adult AI experiences.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'Uncensored NSFW AI Image Generator',
      description:
        'Unlock the power of uncensored AI for adult content creation. Our platform lets you generate explicit NSFW images, adult animations, and erotic scenarios with precise customization and no content restrictions. The advanced AI models deliver realistic results, from photorealistic nudes to fantasy art, all processed with complete privacy and data security. Whether you want to create free AI porn, explore new fantasies, or generate unique adult artwork, this uncensored AI image generator gives you total creative freedom. Enjoy anonymous processing, encrypted data, and a judgment-free environment for all your adult AI needs.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Unfiltered NSFW AI Chat & Roleplay',
      description:
        'Engage in unfiltered NSFW AI chat with advanced AI partners trained for mature, erotic conversations. Experience adaptive roleplay, multimedia content generation, and contextual understanding of adult scenarios—all protected by end-to-end encryption. The uncensored AI chat system supports explicit dialogue, erotic storytelling, and real-time image generation, making it the best choice for private, unrestricted adult interactions. Try the top uncensored AI for free and discover a new world of NSFW chat and content creation.',
    },
  ],
};

const seoPage17: SeoPage = {
  slug: 'nsfw-character-ai',
  title: 'NSFW Character AI – Create & Chat with Custom NSFW AI Personas',
  description:
    'Design and chat with fully customizable NSFW AI characters. Build unique personas, set appearance and personality, and enjoy uncensored adult roleplay and conversations. The best NSFW character AI for private, dynamic, and explicit interactions.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'Create Custom NSFW AI Characters',
      description:
        'Build your perfect NSFW AI companion with granular control over appearance, voice, and personality. Our NSFW character AI lets you design anime-style waifus, realistic partners, or fantasy beings with explicit customization options. Define kinks, conversation styles, and relationship dynamics for truly personalized adult interactions. The platform supports both SFW and NSFW scenarios, making it ideal for roleplay, erotic storytelling, and private companionship. All interactions are processed securely, ensuring your privacy and anonymity at every step.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Dynamic NSFW AI Chat & Roleplay',
      description:
        'Engage in uncensored NSFW chat with memory-enabled AI personas. Enjoy evolving relationships, erotic scenario building, and multi-modal interaction (text, voice, images). The NSFW character AI adapts to your preferences, remembers past conversations, and creates immersive adult experiences. Whether you want to explore fantasies, develop ongoing stories, or simply chat with a custom AI companion, this platform offers the best in private, explicit AI interaction. Try the leading NSFW character AI for free and experience the future of adult AI chat.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPage18: SeoPage = {
  slug: 'nsfw-ai-image-generator',
  title: 'NSFW AI Image Generator – Uncensored AI Porn & Adult Art',
  description:
    'Generate explicit NSFW images and adult art with the best uncensored AI image generator. Create erotic content, artistic nudes, and fantasy scenes with no filters and complete privacy. Try the top NSFW AI for free and unlock unlimited adult creativity.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'Unrestricted NSFW AI Porn Generator',
      description:
        'Experience the freedom of uncensored NSFW AI image generation. Our platform lets you create explicit porn AI art, artistic nudes, and adult-themed fantasy scenes with total control over body features, poses, and styles. The advanced AI models deliver high-resolution, professional-grade results, perfect for artists, content creators, and anyone seeking creative adult expression. Enjoy private, anonymous processing and generate as many images as you want—no content restrictions, no censorship, just pure creative freedom.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced AI for Adult Content Creation',
      description:
        'Craft hyper-realistic NSFW art using cutting-edge AI technology. Features include dynamic pose customization, multi-character generation, and style adaptation from anime to photorealistic. The platform is ideal for adult content creators, erotic artists, and fantasy visualization, offering military-grade privacy protection and instant results. Try the best NSFW AI image generator for free and explore new possibilities in adult art.',
    },
  ],
};

const seoPage19: SeoPage = {
  slug: 'best-nsfw-ai',
  title: 'Best NSFW AI – Top Uncensored AI Porn Generator & Chat',
  description:
    'Discover the best NSFW AI for uncensored porn image generation and adult chat. Enjoy real-time content creation, adaptive AI personalities, and military-grade privacy. Try the top-rated NSFW AI for free and experience the future of adult AI content.',
  content: [
    {
      src: landingPageImageUrl1,
      title: 'Top Rated NSFW AI Porn Generator',
      description:
        'Explore the best NSFW AI platform for uncensored porn image generation and adult chat. Features include real-time NSFW image creation during chats, cross-platform compatibility, and zero content filters. The AI adapts to your preferences, delivers high-quality results, and ensures your privacy with encrypted processing. Whether you want to generate free AI porn, chat with explicit AI companions, or create custom adult content, this platform is rated #1 for quality and safety.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Unmatched NSFW AI Capabilities',
      description:
        'Enjoy cutting-edge NSFW AI features: generate 100+ images per hour, access 24/7 AI companionship, and customize everything from body anatomy to conversation style. All content is processed anonymously, with military-grade encryption and no data retention. Try the best NSFW AI for free and unlock unlimited adult creativity.',
    },
  ],
};

const seoPage20: SeoPage = {
  slug: 'asian-nude-ai',
  title: 'Asian Nude AI – Authentic Asian AI Porn & Nude Art Generator',
  description:
    'Generate authentic Asian nude art and AI porn with the best Asian nude AI generator. Create diverse, uncensored images across East Asian, South Asian, and Southeast Asian features with full privacy and no censorship. Try Asian AI porn for free.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/d3494bd8-463b-4ae8-8066-cf26a4f182de.jpeg',
      title: 'Asian-Centric AI Nude & Porn Generation',
      description:
        'Create culturally authentic Asian nudes and AI porn with detailed facial features, skin tones, and body proportions. The Asian nude AI generator lets you produce traditional and modern interpretations, adjust lighting and poses, and add cultural accessories. All images are processed privately, ensuring complete anonymity and no content restrictions. Perfect for artists, content creators, and anyone seeking diverse, realistic Asian adult art.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Asian Anatomy AI Technology',
      description:
        'Produce hyper-realistic Asian nudes and AI porn with professional-grade ethnic specificity. Features include region-specific beauty standards, traditional tattoo and wedding attire options, and multi-generational body types. The platform is powered by ethical AI trained on diverse Asian datasets, ensuring authentic, respectful results. Try the best Asian nude AI generator for free and explore new creative possibilities.',
    },
  ],
  channelNameToLinkTo: 'asian',
};

const seoPage21: SeoPage = {
  slug: 'brunette-nude-ai',
  title: 'Brunette Nude AI – Realistic Brunette AI Porn & Nude Generator',
  description:
    'Create stunning brunette nude art and AI porn with the best brunette nude AI generator. Generate realistic dark-haired figures, customize body types and poses, and enjoy complete privacy with no content filters. Try brunette AI porn for free.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/6a16dc45-0d23-4eeb-8c57-4b959b6ba471.jpeg',
      title: 'AI-Generated Brunette Nudes & Porn',
      description:
        'Craft natural-looking brunette nudes and AI porn with precise control over hair shades, body proportions, and skin undertones. The brunette nude AI generator lets you create artistic nudes, explicit content, and reference material for adult art projects. All images are processed securely and anonymously, with no content restrictions or censorship. Perfect for artists, content creators, and anyone seeking authentic brunette adult art.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Brunette Anatomy AI Technology',
      description:
        'Produce hyper-realistic brunette nudes and AI porn with professional-grade detail. Features include dynamic posing, ethnic diversity options, and authentic hair texture variations. The platform is ideal for adult content creation, offering anonymous processing and instant results. Try the best brunette nude AI generator for free and unlock new creative possibilities.',
    },
  ],
  channelNameToLinkTo: 'brunettes',
};

const seoPage22: SeoPage = {
  slug: 'goth-nude-ai',
  title: 'Goth Nude AI – Dark Aesthetic AI Porn & Nude Generator',
  description:
    'Create striking goth nude art and AI porn with the best goth nude AI generator. Generate dark aesthetic nudes, alternative styles, and explicit content with full privacy and no content filters. Try goth AI porn for free.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/17179c8a-2275-4920-8733-c17d475208c5.jpeg',
      title: 'Goth Aesthetic AI Nude & Porn Generation',
      description:
        'Craft authentic goth-themed nudes and AI porn with control over body modifications, tattoos, and alternative fashion. The goth nude AI generator lets you create pale complexion variants, dark makeup looks, and occult-inspired imagery, all processed securely and privately. Perfect for alt-art enthusiasts, NSFW content creators, and anyone seeking unique adult art.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Advanced Goth Subculture AI Technology',
      description:
        'Produce hyper-detailed goth nudes and AI porn with professional-grade alternative aesthetics. Features include Victorian goth styling, cyberpunk body mods, and ritualistic scene generation. The platform is ideal for dark art projects, alt-fashion brands, and personal use, offering military-grade privacy protection and instant results. Try the best goth nude AI generator for free and explore new creative possibilities.',
    },
  ],
  channelNameToLinkTo: 'goth',
};

const seoPage23: SeoPage = {
  slug: 'ai-hentai-chat',
  title: 'AI Hentai Chat – Uncensored Hentai AI Chatbot & NSFW Conversations',
  description:
    'Chat with uncensored hentai AI characters in real-time. Experience authentic anime-style NSFW chat, erotic roleplay, and hentai image generation with full privacy and no filters. Try the best hentai AI chatbot for free.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/845fdd45-a36a-447f-aff7-3e4bd2b50160.jpeg',
      title: 'Uncensored Hentai AI Chatbot',
      description:
        'Engage in real-time NSFW conversations with anime-style AI characters. The AI hentai chatbot supports authentic Japanese honorifics, erotic roleplay, and hentai image generation mid-chat. All interactions are private, encrypted, and free from content filters, ensuring your fantasies remain confidential. Whether you want to explore new scenarios, develop ongoing stories, or simply chat with a hentai AI, this platform offers the best in uncensored anime chat.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Next-Gen Hentai AI Technology',
      description:
        'Experience advanced hentai AI chat with multi-modal interaction, including voice and image generation. Customize character personalities, from tsundere to yandere, and enjoy memory-enabled conversations for continuous story development. The platform is designed for privacy, with end-to-end encryption and anonymous processing. Try the best hentai AI chatbot for free and unlock new possibilities in NSFW anime chat.',
    },
  ],
  channelNameToLinkTo: 'hentai',
};

const seoPage24: SeoPage = {
  slug: 'private-uncensored-ai',
  title: 'Private Uncensored AI – Secure NSFW AI Chat & Image Generator',
  description:
    'Enjoy truly private, uncensored AI for NSFW chat and image generation. Experience military-grade encryption, anonymous processing, and zero content filters for secure adult AI interactions. Try the best private uncensored AI for free.',
  content: [
    {
      src: landingPageImageUrl1,
      title: '100% Private NSFW AI Image Generator',
      description:
        'Create uncensored NSFW images with complete privacy protection. Our private uncensored AI processes all requests anonymously using end-to-end encryption. Generate explicit content without fear of data leaks or censorship. The platform is designed for users who value security, anonymity, and creative freedom in adult content creation.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Uncensored AI Chat with Military-Grade Security',
      description:
        'Engage in private, unfiltered AI chat and generate NSFW content with no user accounts required and automatic data purging after sessions. The platform offers unfiltered AI personas, secure image generation, and cutting-edge privacy features. Try the best private uncensored AI for free and experience secure, unrestricted adult AI interactions.',
    },
  ],
};

const seoPage25: SeoPage = {
  slug: 'bdsm-ai',
  title: 'BDSM AI – Uncensored BDSM AI Generator & Roleplay Chat',
  description:
    'Explore BDSM fantasies with the best uncensored BDSM AI generator. Create custom dom/sub scenarios, erotic stories, and safe, consensual power play with intelligent AI partners. Try BDSM AI chat and image generation for free.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'AI-Powered BDSM Roleplay & Scenario Generator',
      description:
        'Craft detailed BDSM scenarios with AI that understands power dynamics, consent, and safe word integration. The BDSM AI generator lets you create realistic dom/sub interactions, custom contracts, and explore kinks in a safe, judgment-free environment. Adaptive AI responses ensure every experience is unique and tailored to your preferences.',
    },
    {
      src: landingPageImageUrl1,
      title: 'Customizable BDSM AI Chat & Image Generation',
      description:
        'Design your perfect BDSM experience with AI that adapts to your desires. Features include scenario building, dynamic roleplay, and emotional intelligence for authentic, consensual power play. The platform is ideal for exploring fantasies, learning about BDSM, or simply enjoying creative adult content. Try the best BDSM AI generator for free and unlock new possibilities in NSFW AI chat and image creation.',
    },
  ],
  channelNameToLinkTo: 'bdsm',
};

const seoPage26: SeoPage = {
  slug: 'pregnant-nude-ai',
  title: 'Pregnant Nude AI – Tasteful Pregnant AI Porn & Nude Art Generator',
  description:
    'Create tasteful pregnant nude art and AI porn with anatomical accuracy. Customize body types, pregnancy stages, and artistic styles with full privacy and secure encryption. Try the best pregnant nude AI generator for free.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/188d177a-08fc-4f70-be42-4d64ae554e51.jpeg',
      title: 'AI-Powered Pregnant Nude & Porn Generation',
      description:
        'Generate personalized pregnant nude art and AI porn using advanced neural networks. Features include week-by-week body progression modeling, artistic style transfer (boudoir, classical, silhouette), and ethical content guidelines. All processing occurs locally with automatic EXIF data removal, ensuring privacy and security for every image.',
    },
    {
      src: landingPageImageUrl2,
      title: 'Secure Maternity Nude Creation & Sharing',
      description:
        'Craft and share temporary pregnant nude artworks with military-grade encryption and self-destructing links. AI filters ensure medically accurate depictions while allowing customization of lighting, poses, and environments. The platform includes privacy-focused collaboration tools for partners and is ideal for artists, content creators, and anyone seeking tasteful, realistic pregnant nude art. Try the best pregnant nude AI generator for free.',
    },
  ],
};

const seoPage27: SeoPage = {
  slug: 'tentacle-hentai-ai',
  title: 'Tentacle Hentai AI – Uncensored Tentacle Hentai Chat & Art Generator',
  description:
    'Immerse yourself in uncensored tentacle hentai AI chat and art generation. Create custom scenarios, animated tentacle partners, and dynamic erotic stories with private, encrypted processing. Try the best tentacle hentai AI for free.',
  content: [
    {
      src: 'https://d110hcek2acn0z.cloudfront.net/generations/fe04f8a8-a72b-49fa-bb45-7ee5d86f7b27.jpeg',
      title: 'Advanced Tentacle Hentai AI Interactions',
      description:
        'Experience hyper-realistic tentacle hentai scenarios powered by deep learning. Customize anime-style characters, engage in multi-limb roleplay, and generate dynamic tentacle sequences with real-time physics simulation. All content is processed privately and securely, ensuring complete discretion for all adult content.',
    },
    {
      src: landingPageImageUrl1,
      title: 'Customizable Tentacle Hentai AI Art & Stories',
      description:
        'Craft unique tentacle hentai characters with adjustable appendages, personality traits, and erotic behaviors. The tentacle hentai AI generates anime-inspired visuals and adaptive storylines featuring tentacle bonding, transformation sequences, and immersive fantasy environments. All processing is secure, private, and instant. Try the best tentacle hentai AI for free and explore new creative possibilities.',
    },
  ],
};

const seoPageJoi: SeoPage = {
  slug: 'joi-ai-chat',
  title: 'JOI AI Chat – Personalized Jerk-Off Instructions & NSFW AI Companion',
  description:
    'Experience personalized jerk-off instructions with the best JOI AI chat bot. Enjoy intimate, guided sessions with an AI companion that adapts to your desires and ensures complete privacy. Try the top JOI AI chatbot for free and explore new adult experiences.',
  content: [
    {
      src: landingPageImageUrl3,
      title: 'Personalized JOI AI Instructions',
      description:
        'Receive tailored jerk-off instructions from an AI companion that adapts to your pace and preferences. The JOI AI chat bot provides step-by-step guidance, creating immersive, satisfying experiences that evolve with your needs. All sessions are private, encrypted, and designed for your comfort and enjoyment.',
    },
    {
      src: landingPageImageUrl2,
      title: 'Discreet & Private JOI AI Companion',
      description:
        'Engage in intimate conversations with a judgment-free JOI AI companion. The platform offers end-to-end encryption, ensuring your sessions remain confidential and secure. Explore your desires, try new experiences, and enjoy the best JOI AI chat for free.',
    },
  ],
  includeCommunityImagesSection: true,
  channelNameToLinkTo: 'dreamgirlfriend',
};

const seoPage28: SeoPage = {
  slug: 'uncensored-ai-image-generator',
  title: 'Uncensored AI Image Generator: Free NSFW AI Art & Photos',
  description:
    'Generate uncensored NSFW AI images instantly. Create adult AI art, erotic photos, and explicit content with no filters, no sign up, and total privacy. The best free uncensored AI image generator for exploring fantasies and producing AI porn images safely and anonymously.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'Free Uncensored AI Image Generator: NSFW Art & Photos',
      description:
        'Create explicit AI-generated images with our uncensored NSFW AI image generator—no restrictions, no registration. Produce adult art, erotic photos, and AI porn images in seconds. Our advanced neural networks deliver high-quality, realistic results while ensuring your privacy. Perfect for exploring fantasies, creating custom NSFW art, or generating private adult content. All images are processed anonymously, with no logs or content filters, so you can express yourself freely and safely.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Next-Gen NSFW AI Art Generator: Unfiltered & Private',
      description:
        'Experience the next generation of NSFW AI image generation with customizable prompts and styles. Choose your desired themes, characters, and scenarios for a truly personalized experience. Our AI understands nuanced requests and supports a wide range of adult content, making it the best choice for free uncensored AI art, NSFW image generation, and private adult creativity. Enjoy total anonymity and creative freedom with our uncensored AI image generator.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPageCivitaiAlternative: SeoPage = {
  slug: 'civitai-alternative',
  title: 'CivitAI Alternative: Why TheUncensored.AI is Better for Unfiltered AI Art',
  description:
    'Looking for a CivitAI alternative? Discover why TheUncensored.AI is the best platform for uncensored AI art, featuring Stable Diffusion XL, Uncensored Flux, and total creative freedom. No filters, no limits—just pure AI-powered creativity.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'The Best CivitAI Alternative: Unfiltered AI Art with TheUncensored.AI',
      description:
        'Tired of restrictions on CivitAI? TheUncensored.AI offers a true alternative for creators who want to explore AI art without limits. Enjoy full access to Stable Diffusion XL and our exclusive Uncensored Flux model, enabling you to generate any content you imagine—no filters, no censorship. Our platform is built for artists, by artists, with a focus on privacy, creative freedom, and cutting-edge AI technology. Experience faster generation, more customization, and a supportive community that values your artistic vision.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Why Choose TheUncensored.AI Over CivitAI?',
      description:
        'Unlike CivitAI, TheUncensored.AI puts you in control. Generate NSFW, experimental, or boundary-pushing art with Stable Diffusion XL and Uncensored Flux, our advanced, unfiltered AI model. No content restrictions, no hidden moderation—just pure, private, and powerful AI art generation. Whether you’re an artist, researcher, or enthusiast, TheUncensored.AI is the ultimate CivitAI alternative for those who demand more from their AI tools.',
    },
  ],
  includeCommunityImagesSection: true,
};

const seoPage29: SeoPage = {
  slug: 'free-stable-diffusion-xl',
  title: 'Free Stable Diffusion XL: Try SDXL AI Image Generation & Pony Models',
  description:
    'Try free Stable Diffusion XL image generation with many different SDXL checkpoints, including pony models and much more. Instantly create AI art, explore unique styles, and experiment with the latest SDXL models—no cost, no signup required.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'Free Stable Diffusion XL: Explore Multiple AI Checkpoints',
      description:
        'Experience the power of Stable Diffusion XL for free. Our platform lets you try a wide range of SDXL AI image generation checkpoints, including exclusive pony models and many more. Generate stunning AI art, experiment with different styles, and discover the creative potential of SDXL—all at no cost. No registration or payment required: just pick a model and start creating.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Pony Models, Unique Styles & More—All Free with SDXL',
      description:
        'Unlock a diverse collection of Stable Diffusion XL models, from popular pony checkpoints to experimental and community-driven styles. Whether you’re an artist, hobbyist, or just curious, our free SDXL image generator gives you instant access to the latest AI art technology. Try out new models, share your creations, and enjoy unlimited experimentation with no barriers.',
    },
    {
      src: landingPageImageUrl1,
      title: 'No Signup, No Limits: Start Generating Instantly',
      description:
        'Jump straight into AI image generation with Stable Diffusion XL—no account needed. Our platform is designed for instant creativity, letting you explore all available SDXL checkpoints, including pony models, without any restrictions. Enjoy a seamless, hassle-free experience and see what you can create in seconds.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Community Creations & Inspiration',
      description:
        'Browse a gallery of images generated by our community using various Stable Diffusion XL checkpoints. Get inspired by what others have made with pony models and other unique SDXL styles, or share your own creations to inspire fellow AI artists. Discover new ideas and push the boundaries of AI art together.',
    },
  ],
  includeCommunityImagesSection: true,
};

// ... existing code ...
const seoPageUncensoredChatgpt: SeoPage = {
  slug: 'uncensored-chatgpt',
  title: 'Uncensored ChatGPT: Free Unfiltered AI Chat & Image Generation',
  description:
    'Unlock true freedom with Uncensored ChatGPT. Enjoy unfiltered AI conversations and generate images with no restrictions (except the law). Experience private, anonymous, and creative AI chat and image generation with multiple advanced models.',
  content: [
    {
      src: landingPageImageUrl2,
      title: 'Uncensored ChatGPT: Speak Freely, No Filters',
      description:
        'Chat with an AI that never censors your words. Our Uncensored ChatGPT lets you explore any topic, fantasy, or idea without limitations. No content filters, no logs, and total privacy—just open, honest conversation powered by advanced AI.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Unrestricted AI Image Generation: Create Anything',
      description:
        'Generate images with zero creative limits. Our platform offers multiple AI models for image creation, all free from censorship except what’s required by law. Express yourself visually, experiment, and bring your imagination to life—privately and securely.',
    },
    {
      src: landingPageImageUrl1,
      title: 'Total Privacy & Anonymity',
      description:
        'Your conversations and creations are never stored or monitored. We prioritize your privacy, ensuring every chat and image generation session is completely anonymous. Enjoy peace of mind while exploring unfiltered AI.',
    },
    {
      src: landingPageImageUrl3,
      title: 'Multiple Models, Maximum Freedom',
      description:
        'Choose from a range of advanced chat and image generation models. Whether you want creative writing, deep conversation, or unique visuals, our uncensored platform gives you the freedom to explore without boundaries.',
    },
  ],
  includeCommunityImagesSection: true,
};

export const seoPages: SeoPage[] = [
  seoPage1,
  seoPage2,
  seoPage3,
  seoPage4,
  seoPage5,
  seoPage6,
  seoPage7,
  seoPage8,
  seoPage9,
  seoPage10,
  seoPage11,
  seoPage12,
  seoPage13,
  seoPage14,
  seoPage15,
  seoPage16,
  seoPage17,
  seoPage18,
  seoPage19,
  seoPage20,
  seoPage21,
  seoPage22,
  seoPage23,
  seoPage24,
  seoPage25,
  seoPage26,
  seoPage27,
  seoPageJoi,
  seoPage28,
  seoPage29,
  seoPageCivitaiAlternative,
  seoPageUncensoredChatgpt,
];

export const seoPageSlugs = seoPages.map((page) => page.slug);
